import { color } from '@lemonade-hq/cdk';
import { css, createGlobalStyle } from 'styled-components';
import { reset } from 'styled-reset';
import { fontFaces } from './typography.esm.js';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n\n  html, body {\n    -webkit-font-smoothing: antialiased;\n    -moz-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: ",
        "px;\n    color: ",
        ";\n  }\n\n  * {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  b {\n    font-weight: 700;\n  }\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  h1 {\n    font-size: 7.2rem;\n  }\n\n  h2 {\n    font-size: 4.8rem;\n  }\n\n  h3 {\n    font-size: 3rem;\n  }\n\n  h5 {\n    font-size: 1.6rem;\n  }\n\n  h6 {\n    font-size: 1.4rem;\n  }\n\n  ::selection {\n    background: ",
        ";\n    color: ",
        ";\n    text-shadow: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var BASE_FONT_SIZE = 10;
var GlobalCSS = css(_templateObject(), reset, fontFaces, BASE_FONT_SIZE, color("borderDark"), color("textLink"), color("backgroundPink"), color("invertedTextPrimary"));
var GlobalStylesheet = createGlobalStyle(_templateObject1(), GlobalCSS);

export { BASE_FONT_SIZE, GlobalCSS, GlobalStylesheet };
